<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-09 18:10:23
 * @LastEditTime: 2019-09-03 17:04:37
 * @LastEditors: Please set LastEditors
 -->
<template>
    <div class="add container">
              <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane label="基本资料" name="first" >
                        <el-form ref="form" :model="form" label-width="80px" :rules="rules">
                            <el-form-item label="员工名称" prop="dealer_name">
                                <el-input v-model="form.dealer_name" :readonly="readonly"></el-input>
                            </el-form-item>
                              <el-form-item label="账号" prop="mobile_son">
                                <el-input v-model="form.mobile_son"  :readonly="readonly"></el-input>
                                <span>-{{mobile}}</span>
                            </el-form-item>
                              <el-form-item label="密码" prop="password">
                                <el-input v-model="form.password" type='password'  :readonly="readonly"></el-input>
                            </el-form-item>
                              <el-form-item label="确认密码" prop="repassword">
                                <el-input v-model="form.repassword" type='password'  :readonly="readonly"></el-input>
                            </el-form-item>
                              <el-form-item label="备注" >
                                <el-input v-model="form.msg"></el-input>
                            </el-form-item>
                            
                            </el-form>
                    <div class="footer">
                         <el-button type="primary" @click="save()">保存</el-button>
                         <el-button @click="$router.go(-1)">返回</el-button>

                    </div>
                </el-tab-pane>
                <el-tab-pane label="分配权限" name="second">
                     
                            <el-tree
                                ref='tree'
                                @check-change='getData'
                                :data="list"
                                show-checkbox
                                node-key="id"
                                :default-expand-all="true"
                                :default-checked-keys="defaultChecked"
                                :props="defaultProps">
                            </el-tree>

                     
                    <div class="footer">
                         <el-button type="primary" @click="save">保存</el-button>
                         <el-button @click='back'>返回</el-button>

                    </div>
                </el-tab-pane>
            
            </el-tabs>
    </div>
</template>

<script>
import { setTimeout } from 'timers';
export default {
    name:'addStaff',
    data(){
        return{
            activeName:'first',
            activeNames:"",
            form:{},
            mobile:"",
            readonly:false,
            rules:{
              dealer_name:[
                  { required: true, message: '请输入员工名称', trigger: 'blur' },
              ],
              mobile_son:[
                  { required: true, message: '请输入账号', trigger: 'blur' },
              ],
              password:[
                  { required: true, message: '请输入密码', trigger: 'blur' },
               
              ],
              repassword:[
                  { required: true, message: '请再次输入密码', trigger: 'blur' },
               
              ]
            },
            data: [{
          id: 1,
          label: '一级 1',
          children: [{
            id: 4,
            label: '二级 1-1',
            children: [{
              id: 9,
              label: '三级 1-1-1'
            }, {
              id: 10,
              label: '三级 1-1-2'
            }]
          }]
        }, {
          id: 2,
          label: '一级 2',
          children: [{
            id: 5,
            label: '二级 2-1'
          }, {
            id: 6,
            label: '二级 2-2'
          }]
        }, {
          id: 3,
          label: '一级 3',
          children: [{
            id: 7,
            label: '二级 3-1'
          }, {
            id: 8,
            label: '二级 3-2'
          }]
        }],
        list:[],
        defaultChecked:[],
        checkList:[],
        defaultProps: {
          children: 'children',
          label: 'label'
        }
        }
    },
    created(){
      this.init()
    },
    methods:{
        handleClick(){
            
        },
        init(){
          if(this.$route.query.edit){
            this.readonly=true
             this.mobile=sessionStorage.getItem('mobile')
              this.$get('logistics_2','publics/Dealerpc.Dealerpc/editveendorrbac',{
                customer_id:sessionStorage.getItem('customer_id'),
                  mobile:sessionStorage.getItem('mobile'),
                  mobile_son:this.$route.query.edit
              }).then(res=>{
                this.list=res.menu
                res.menu.forEach(element => {
                  if(element.check){
                    this.defaultChecked.push(element.id)
                  }
                 
                    if(element.children){
                        element.children.forEach(v => {
                        if(v.check){
                            this.defaultChecked.push(v.id)
                          
                        }
                    });
                    }
            this.checkList=this.defaultChecked
                   
                });
                console.log(this.defaultChecked)
                this.activeNames=this.list[0].id
              })
              this.$get('logistics_2','publics/Dealerpc.Dealerpc/geteidtVendor',{
                customer_id:sessionStorage.getItem('customer_id'),
                  mobile:sessionStorage.getItem('mobile'),
                  mobile_son:this.$route.query.edit
              }).then(res=>{
                  this.form=res.msg
                  this.form.repassword=res.msg.password
                  this.form.mobile_son=res.msg.mobile.replace('-'+sessionStorage.getItem('mobile'),"")
              })
          }else{
            this.readonly=false
               this.mobile=sessionStorage.getItem('mobile')
          this.$get('logistics_2','publics/Dealerpc.Dealerpc/addvendorrbac',{
             customer_id:sessionStorage.getItem('customer_id'),
              mobile:sessionStorage.getItem('mobile'),
          }).then(res=>{
            this.list=res.menu
            this.activeNames=this.list[0].id

          })
          }
         
        },
            loadNode(node, resolve) {
        if (node.level === 0) {
          return resolve([{ name: 'region' }]);
        }
        if (node.level > 1) return resolve([]);

        setTimeout(() => {
          const data = [{
            name: 'leaf',
            leaf: true
          }, {
            name: 'zone'
          }];

          resolve(data);
        }, 500);
      },
      handleCheckChange(change){
          
      },
      getData(leafOnly){
        this.checkList=[]

          this.checkList=this.$refs.tree.getCheckedKeys().concat(this.$refs.tree.getHalfCheckedKeys())

      },
      back(){
  that.$router.push({
                    name:'staffManagement'
                  })
      },
      save(){
        if(this.$route.query.edit){
            this.$refs['form'].validate((valid) => {
          if (valid) {
            if(this.form.repassword!==this.form.password){
               this.$message({
                type:'error',
                message:'两次密码输入不一致'
              })
              return;
            }
                  if(this.checkList.length==0){
                      this.$message({
                              type:'error',
                              message:'至少选中一个权限'
                            })
                    return;
                  }
                this.$get('logistics_2','publics/Dealerpc.Dealerpc/editVendor',{
                  msg:this.form.msg,
                  mobile_son:this.form.mobile_son+'-'+sessionStorage.getItem('mobile'),
                  permissions:this.checkList,
                   customer_id:sessionStorage.getItem('customer_id'),
                  mobile:this.mobile?this.mobile:sessionStorage.getItem('mobile'),
              }).then(res=>{
              this.$message({
                type:'success',
                message:'成功'
              })
              var that=this
              setTimeout(()=>{
                  that.$router.push({
                    name:'staffManagement'
                  })
              },500)
            })
          } else {
            return false;
          }
        });
        }else{

          this.$refs['form'].validate((valid) => {
          if (valid) {
            if(this.form.repassword!==this.form.password){
               this.$message({
                type:'error',
                message:'两次密码输入不一致'
              })
              return;
            }
                  if(this.checkList.length==0){
                      this.$message({
                              type:'error',
                              message:'至少选中一个权限'
                            })
                    return;
                  }
                this.$get('logistics_2','publics/Dealerpc.Dealerpc/addVendor',{
                  ...this.form,
                  permissions:this.checkList,
                   customer_id:sessionStorage.getItem('customer_id'),
                  mobile:this.mobile?this.mobile:sessionStorage.getItem('mobile'),
              }).then(res=>{
              this.$message({
                type:'success',
                message:'成功'
              })
              var that=this
              setTimeout(()=>{
                  that.$router.push({
                    name:'staffManagement'
                  })
              },500)
            })
          } else {
            return false;
          }
        });
      
        }
      }
      
   
        
    }
}
</script>

<style lang="scss" scoped>
/deep/.el-input{
    width: 200px!important;
} 
.footer{
    text-align: center;
    margin-top: 50px;
}
</style>


